// extracted by mini-css-extract-plugin
export default {"cpAcccordionHeader":"app__DetailsPage__cpAcccordionHeader","cpDetailsBuildingIcon":"app__DetailsPage__cpDetailsBuildingIcon"};